import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { format } from 'date-fns'
import PropTypes from 'prop-types'

import { Box, Typography } from '@mui/material'

const DateInterface = ({ viewingDate, setViewingDate, today }) => {
  const isViewingToday = () => {
    return format(viewingDate, 'yyyy-MM-dd') === format(today, 'yyyy-MM-dd')
  }

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          margin='normal'
          id='start-date-picker'
          format='MM/dd/yyyy'
          value={viewingDate}
          onChange={setViewingDate}
          KeyboardButtonProps={{
            'aria-label': 'change date'
          }}
          OpenPickerButtonProps={{ style: { color: 'white' } }}
          disableFuture
          renderInput={({ inputRef, InputProps }) => (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {InputProps?.endAdornment}
              <Typography variant='h3' ref={inputRef} sx={{ color: 'white', marginLeft: 2 }}>{`${isViewingToday() ? 'Today' : format(viewingDate, 'MMM, dd yyyy')}`}</Typography>
            </Box>
          )}
        />
      </LocalizationProvider>
    </>
  )
}

DateInterface.propTypes = {
  viewingDate: PropTypes.any,
  setViewingDate: PropTypes.func,
  today: PropTypes.any
}

export default DateInterface
